import React from "react";

const ExperienceData = ({ work }) => {
  //   console.log("work -->", work);
  return (
    <div>
      <div className="flex flex-col lg:flex-row lg:items-center justify-between mb-4">
        <div>
          <h3 className="text-lg font-bold text-gray-900 mb-1">
            {work?.companyName}
          </h3>
          <p className="text-base text-blue-600 font-medium">
            {work?.positionHeld}
          </p>
        </div>
        <div className="flex flex-col lg:items-end mt-2 lg:mt-0">
          <span
            classწ
            className="inline-flex items-center px-3 py-1 bg-white text-gray-700 text-sm font-medium rounded-lg border mb-1"
          >
            From: {work?.startYear} To: {work?.finishYear}
          </span>
          <span className="inline-flex items-center px-3 py-1 bg-green-100 text-green-700 text-sm font-medium rounded-lg">
            Salary: {work?.salary}
          </span>
        </div>
      </div>
      <p className="text-gray-700 mb-2 leading-relaxed">
        {work?.jobDescription}
      </p>
      <div className="text-gray-700 mb-6">
        <span className="font-medium">Reason for Leaving: </span>
        <span>{work?.reasonForLeaving}</span>
      </div>
      {/* Reference Contact */}
      <div className="bg-white rounded-lg p-4 border border-gray-200">
        <h4 className="text-sm font-bold text-gray-800 mb-3">
          Reference Contact
        </h4>
        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-3">
          <div>
            <span className="font-medium text-gray-700 text-sm">Name: </span>
            <span className="text-gray-600 text-sm">{work?.contactPerson}</span>
          </div>
          <div>
            <span className="font-medium text-gray-700 text-sm">Phone: </span>
            <span className="text-gray-600 text-sm">{work?.contactPhone}</span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ExperienceData;
